import Swiper from "swiper";

/**
 * QuoteSlider class
 */
export default class QuoteSlider {
    constructor() {
        /**
         *
         * @type {{slider: string, sliderNext: string, sliderPrev: string, sliders: string}}
         * @private
         */
        this.defaults = {
            //elements
            sliders: ".js-quote-slider-wrapper",
            slider: ".js-slider",
            sliderNext: ".js-slider-next",
            sliderPrev: ".js-slider-prev",
        };
    }

    //region methods
    /**
     * QuoteSlider class init method and init flag
     */
    init() {
        console.log("QuoteSlider init()");

        const sliders = document.querySelectorAll(this.defaults.sliders);

        if (sliders.length > 0) {
            this.sliderController(sliders);
        }
    }

    sliderController(sliders) {
        sliders.forEach((sliderWrapper) => {
            const slider = sliderWrapper.querySelector(this.defaults.slider);
            const swiper = new Swiper(slider, {
                speed: 400,
                shortSwipes: true,
                slidesPerView: 1,
                effect: "fade",
                fadeEffect: {
                    crossFade: false,
                },
                navigation: {
                    nextEl: sliderWrapper.querySelector(this.defaults.sliderNext),
                    prevEl: sliderWrapper.querySelector(this.defaults.sliderPrev),
                },
                breakpoints: {
                    600: {
                        shortSwipes: false,
                    },
                },
            });

            if (swiper.slides.length < 2) {
                sliderWrapper.querySelector(this.defaults.sliderNext).style.display = "none";
                sliderWrapper.querySelector(this.defaults.sliderPrev).style.display = "none";
            }
        });
    }

    //endregion
}
